module.exports = __webpack_public_path__ + "be44712a136a76a9704ff2fcc92e4ed3.png";